import { useTranslator } from '@bluebeam/react-i18n';
import { product } from 'copy/copy';
import heroCloud from 'images/index-page/bluebeam-cloud-hero.png';
import hero from 'images/index-page/bluebeam-cloud-hero-mobile.png';
import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  queryParams: string;
}

const Hero = (props: Props): ReactElement => {
  const { translate } = useTranslator(['index', 'buttons']);

  return (
    <div className="index-hero w100" style={{ flex: 1 }}>
      <div className="index__container">
        <div className="w100 row justfy-between items-center">
          <div className="index-hero__column">
            <div className="index-hero__column_content column">
              <h2 className="index-hero__subheader">
                {translate('index:landing.productName')}
              </h2>
              <h1 className="bold index-hero__header pb2">
                {translate('index:landing.pageTitle')}
              </h1>
              <img
                className="index-hero__cloud--mobile"
                src={hero}
                alt={product.productName}
              />
              <>
                <p className="index-hero__content mt0">
                  {translate('index:landing.heroContent')}
                </p>
              </>
              <div className="index-hero__buttons mb5">
                <Link
                  to={`/my-workspace${props.queryParams}`}
                  className="btn bold decoration-none flex-center font-size-5"
                  style={{
                    backgroundColor: '#0083DB',
                    borderRadius: '3px',
                    padding: '11px 15px',
                    width: '13rem',
                    height: '4rem',
                  }}
                  id="hero-sign-in"
                >
                  {translate('buttons:signIn')}
                </Link>
              </div>
            </div>
          </div>
          <div className="index-hero__column index-hide-mobile column items-end justify-center">
            <img
              className="index-hero__cloud"
              src={heroCloud}
              alt={product.productName}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
